import React from "react";
import PropTypes from "prop-types";
import FileUploadSectionV1 from "./FileUploadSectionV1";
import FileUploadSectionV2 from "./FileUploadSectionV2";

export const FileUploadSectionVersion = {
  v1: "v1",
  v2: "v2",
};

export function FileUploadSection({ version, ...props }) {
  if (version === FileUploadSectionVersion.v1) {
    return <FileUploadSectionV1 {...props} />;
  }

  return <FileUploadSectionV2 {...props} />;
}

FileUploadSection.propTypes = {
  version: PropTypes.oneOf([
    FileUploadSectionVersion.v1,
    FileUploadSectionVersion.v2,
  ]),
  label: PropTypes.string,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  fileTypeOptions: PropTypes.arrayOf(PropTypes.string),
  defaultFileType: PropTypes.string,
  defaultId: PropTypes.string,
  defaultVersion: PropTypes.number,
};

FileUploadSection.defaultProps = {
  version: FileUploadSectionVersion.v2,
  label: "Upload File",
  onSave: () => {},
  onCancel: () => {},
  fileTypeOptions: ["Video", "Audio"],
  defaultFileType: "",
  defaultId: "",
  defaultVersion: 1,
};

export default FileUploadSection;
